module.exports = __webpack_public_path__ + "static/img/story_us.bacf4f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/story_us.png
// module id = IHeE
// module chunks = 1